import React from "react";
import Navbar from "../../component/JinraiUI/Navbar";
import Footer from "../../component/JinraiUI/Footer";
import H1 from "../../assets/images/pp.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const TermsConditions = () => {
    return (
        <>
            <Navbar />

            {/* Hero Section */}
            <section className="relative flex flex-col items-center justify-center md:h-[80vh] h-[60vh] bg-[#f4f4f4]">
                <img
                    src={H1}
                    alt="Background of an innovative agency providing expert project management and technology solutions"
                    className="absolute inset-0 object-cover md:h-[70vh] h-[50vh]  w-full"
                />

                {/* Black Overlay */}
                <div className="absolute inset-0 bg-[#852D2D] opacity-30 md:h-[70vh] h-[50vh] "></div>

                {/* Content */}
                <div className="relative z-10 text-center text-white">
                    <motion.h1
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{
                            delay: 0.2,
                            x: { type: "spring", stiffness: 60 },
                            opacity: { duration: 1 },
                            ease: "easeIn",
                            duration: 1,
                        }}
                        className="md:text-7xl text-4xl font-bold leading-tight mb-8"
                    >
                        Terms & Conditions
                    </motion.h1>

                    <motion.div
                        initial={{ y: 100, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{
                            delay: 0.6,
                            y: { type: "spring", stiffness: 60 },
                            opacity: { duration: 0.7 },
                            ease: "easeIn",
                            duration: 1,
                        }}
                        className="flex justify-center items-center space-x-4 px-6 py-2 md:mx-64"
                    >
                        <Link to="/" className="py-2 transition text-[16px]">
                            Home
                        </Link>
                        <span className=" py-2 transition">{`->`}</span>
                        <Link to="/terms-conditions" className="py-2 transition text-[16px]">
                            Terms & Conditions
                        </Link>
                    </motion.div>
                </div>
            </section>

            <section className="bg-gray-100 pb-20">
                <div className="container mx-auto text-center">
                    <h2 className="text-gray-600 text-sm font-semibold uppercase mb-2">
                        T & C
                    </h2>
                    <h2 className="my-2 md:text-4xl text-3xl text-[--bg-color] font-bold ">
                        Terms & Conditions
                    </h2>

                    {/* Terms Content */}
                    <div className="container mx-auto px-8 md:px-28 max-w-4xl">
                        <div className="my-8 text-left">
                            <ul className="list-disc space-y-3 text-lg leading-relaxed text-gray-700">
                                <li><b>Acceptance: </b>Using our service means you agree to these terms</li>
                                <li><b>Lawful Use: </b>Only use for legitimate business contact sharing</li>
                                <li><b>Your Content: </b>You own it, we get license to display your contact card</li>
                                <li><b>Accounts: </b> Keep login secure, notify us of breaches</li>
                                <li><b>Payments: </b>Subscriptions auto-renew, prices may change</li>
                                {/* <li><b>No Warranty: </b>Service "as is", no guarantees</li> */}
                                <li><b>Termination: </b>We can suspend for violations</li>
                                <li><b>Contact: </b><a href="mailto:contact@jinraitech.com" className="hover:text-yellow-300">contact@jinraitech.com</a> for questions</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default TermsConditions;
